exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estimated-impression-value {\n    position: relative;\n    display: inline-flex;\n    width: 100%\n}\n.estimated-impression-value:hover .warning-msg {\n    display: flex;\n    min-width: 150px;\n}\n.review__estimated {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-width: 70px;\n}", ""]);

// exports
